import { useEffect, useState } from 'react'
import { HttpLCTC } from '../api/httpLCTC'
import { QueryStatus } from 'src/types'
import { OperacionLCTCLimitesAprobadosPais } from '../types/dto'
import { FormFiltros } from '../../../../limites/FiltrosBusqueda'

export const useLimitesLCTC = (filtros: FormFiltros) => {
    const [limites, setLimites] = useState<OperacionLCTCLimitesAprobadosPais[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpLCTC.getLimitesAprobados(filtros)
            .then(value => {
                setLimites(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch()

    useEffect(() => {
        fetch()
    }, [filtros])

    return { limites, refetch, status }
}